<template>
  <div class="content-body">
    <section class="flexbox-container">
      <div class="col-12 d-flex justify-content-center">
        <div class="col-md-4 col-10 box-shadow-2 p-0">
          <div class="card border-grey border-lighten-3 px-1 py-1 m-0">

            <div class="card-body" v-if="mode == 'first'">
              <form class="form-horizontal" v-on:submit.prevent="sendOtp">
                <p>Please confirm your cellphone before registering. An OTP will be sent to your phone.</p>

                <input type="text" class="form-control" id="cellphone" placeholder="Cellphone Number" required v-model="cellphone"><br />

                <div class="form-group text-center">
                  <button type="submit" class="btn btn-block btn-glow btn-primary">Verify Phone</button>
                </div>

              </form>

              <p><router-link to="/login">Back to Login</router-link></p>

            </div>

            <div class="card-body" v-if="mode == 'confirm'">
              <form class="form-horizontal" v-on:submit.prevent="verify">
                <div class="alert alert-success mb-2" role="alert">
                  <strong>SMS Sent!</strong> An SMS with a code has been sent to <strong>{{cellphone}}</strong>. Please type the code below:
                </div>

                <input type="text" class="form-control" id="code" placeholder="OTP Code" required v-model="code"><br />

                <div class="alert alert-danger mb-2" role="alert" v-if="errorMsg2">
                  <strong>Oh snap!</strong> {{errorMsg2}}
                </div>

                <div class="form-group text-center">
                  <button type="submit" class="btn btn-block btn-glow btn-primary">Verify OTP</button>
                </div>

              </form>

              <p><router-link to="/login">Back to Login</router-link></p>

            </div>

          </div>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
export default {
  name: 'verify',
  data: function () {
    return {
      cellphone: '',
      code: '',
      errorMsg: '',
      errorMsg2: '',
      mode: 'first'
    }
  },
  methods: {
    sendOtp: function () {
      $.showLoading()

      var that = this
      this.errorMsg = ''

      var data = {
        cellphone: this.cellphone
      }

      $.ajax({
        complete: function () {
          $.hideLoading()
        },
        url: this.$config.apiUrl + 'basic/verify_cellphone',
        type: 'post',
        data: JSON.stringify(data),
        success: function (data) {
          that.mode = 'confirm'
        },
        error: function (data) {
          var meta = JSON.parse(data.responseText)
          that.errorMsg = meta.message
        }
      })
    },
    verify: function () {
      $.showLoading()

      var that = this
      this.errorMsg2 = ''

      var data = {
        username: this.cellphone,
        otp: this.code
      }

      $.ajax({
        complete: function () {
          $.hideLoading()
        },
        url: this.$config.apiUrl + 'basic/verify_otp',
        type: 'post',
        data: JSON.stringify(data),
        success: function (data) {
          if (data.success === true) {
            window.localStorage.setItem('mobile', that.cellphone)
            that.$router.push('/register')
          } else {
            $('.alert-success').remove()
            that.errorMsg2 = data.message
          }
        },
        error: function (data) {
          var meta = JSON.parse(data.responseText)
          that.errorMsg2 = meta.message
        }
      })
    }
  }
}
</script>
